

<div *ngIf="!chartService.previewMode" [id]="widgetMeta.id"></div>
<div *ngIf="chartService.previewMode" [id]="'preview_' + widgetMeta.id"></div>
<div class="full-chart-container" #fullChart fxLayout="row" fxLayoutAlign="center center"></div>

<div *ngIf="spinner">
  <spinner></spinner>
</div>
